<template>
  <div class="interest">
    <div class="title">选择你感兴趣的标签</div>
    <div class="next" @click="handleBack">跳过</div>
    <div class="interest-block" v-for="(item, index) in interArr" :key="index">
      <div class="block-title">{{index}}</div>
      <div class="block-cons">
        <div class="cons-txt" @click="handleClickItems(item_index, keys)" :class="itemTxt.includes(item_index.tagName) ? 'cur' : ''" v-for="(item_index, keys) in item" :key="keys">{{ item_index && item_index.tagName }}</div>
      </div>
    </div>
    <div class="fix-btn" @click="handleSubmit">我选好了
      <span v-if="itemTxt.length > 0">（已选{{ itemTxt && itemTxt.length }}个）</span>
    </div>
    <returnBack></returnBack>
  </div>
</template>
<script>
import { interestTagList, interestTagSave, iepUserInterestTag } from '@/api/person'
import returnBack from './components/returnBack.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    returnBack
  },
  data () {
    return {
      interArr: [],
      itemTxt: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    iepUserInterestTag({iepUserId: this.userInfo.id}).then(res => {
      this.itemTxt = res.data.map(res => res.interestTag)
    })
    interestTagList().then(res => {
      let obj = {}
      this.interArr = res.data.reduce((pre, cur, index, arr) => {
        if (pre && pre.tagType) {
          obj[pre.tagType] = [pre]
        }
        if (Object.keys(obj).includes(cur.tagType)) {
          obj[cur.tagType].push(cur)
        } else {
          obj[cur.tagType] = [cur]
        }
        return obj
      })
    })
  },
  methods: {
    handleClickItems(item, keys) {
      if (this.itemTxt.includes(item.tagName)) {
        this.itemTxt = this.itemTxt.filter(res => res !== item.tagName)
      } else {
        this.itemTxt.push(item.tagName)
      }
    },
    handleSubmit() {
      if (this.itemTxt.length <= 0) {
        this.$toast('请至少选择一个兴趣标签')
        return
      }
      let params = this.itemTxt.map(res => {
        return {
          iepUserId: this.userInfo.id,
          interestTag: res
        }
      })
      interestTagSave(params).then(res => {
        this.$router.back()
      })
    },
    handleBack() {
      sessionStorage.setItem('interest', 'next')
      this.$router.back()
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.interest {
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  padding: 28px 18px;
  box-sizing: border-box;
  position: relative;

  .title {
    color: rgba(0, 0, 0, .9);
    font-weight: 600;
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 14px;
  }

  .next {
    position: absolute;
    right: 16px;
    top: 28px;
    line-height: 22px;
    font-size: 15px;
    color: rgba(0, 0, 0, .9);
    font-weight: 500;
  }

  .interest-block {
    margin-bottom: 16px;

    .block-title {
      color: rgba(0, 0, 0, .9);
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 9px;
      position: relative;
      padding-left: 6px;
      box-sizing: border-box;
      &::before {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background-color: #EB1700;
        border-radius: 12px;
        content: '';
        width: 3px;
        height: 13px;
      }
    }

    .block-cons {
      display: flex;
      flex-wrap: wrap;

      .cons-txt {
        box-sizing: border-box;
        border-radius: 8px;
        background-color: #F9F8F7;
        font-size: 13px;
        color: #564C47;
        text-align: center;
        line-height: 35px;
        height: 35px;
        margin-bottom: 14px;
        padding:  0 10px;
        margin-right: 10px;
        &.cur {
          border: 1px solid rgb(0, 0, 0);
          border-radius: 4px;
          background: rgb(249, 248, 247);
          color: #000000;
        }
      }
    }
  }

  .fix-btn {
    margin-left: 50%;
    transform: translateX(-50%);
    top: 410px;
    background-color: #EB1700;
    text-align: center;
    line-height: 40px;
    font-size: 15px;
    color: #FFFFFF;
    width: 340px;
    margin-top: 50px;
    border-radius: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/interest.vue